import React from "react";
import { Modal } from "@/components";
import styles from "./ModalLevelInfo.module.scss";

interface ModalLevelInfoProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  level: string;
}

const LEVEL_DESCRIPTIONS: Record<string, { title: string, description: string }> = {
  'Начинающий': {
    title: 'Начальный уровень',
    description: 'Вы знакомитесь с игрой и её правилами, учитесь технике ударов, передвижению по корту, у Вас небольшой игровой опыт или его нет',
  },
  'Средний': {
    title: 'Средний уровень',
    description: 'Вы знакомы с игрой, хорошо знаете правила, у Вас достаточный игровой опыт для турниров',
  },
  'Продвинутый': {
    title: 'Продвинутый уровень',
    description: 'Вы давно играете в padel, у Вас отличная техника, тактика и физическая подготовка',
  },
};

export const ModalLevelInfo: React.FC<ModalLevelInfoProps> = ({
  isOpen,
  setIsOpen,
  level,
}) => {
  const description = LEVEL_DESCRIPTIONS[level] || {
    title: "Информация об уровне",
    description: "Информация об уровне"
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title={description.title}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={handleClose}
      modalWindowWidth={415}
      mobileContentSize="fixed"
    >
      <div className={styles.content}>
        <p className={styles.description}>{description.description}</p>
      </div>
    </Modal>
  );
};
